import React, {RefObject} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import {useTranslation} from 'react-i18next';
import QrZoomScanEffects from '../QrZoom/QrZoomScanEffects';
import * as css from './TicketQr.css';

interface TicketQrProps {
    barcode: string;
    qrWrapRef: RefObject<HTMLDivElement>;
    isScanning: boolean;
    reduceMotion: boolean | null;
    onZoom: () => void;
}

function TicketQr({barcode, qrWrapRef, isScanning, reduceMotion, onZoom}: TicketQrProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.qrWrap ref={qrWrapRef}>
            <css.qr
                type="button"
                $isScanning={isScanning}
                onClick={onZoom}
                aria-label={t('qrAlt')}
                data-cy="ticket-qr"
            >
                <QRCodeCanvas value={barcode} size={200} />
            </css.qr>
            {!reduceMotion && <QrZoomScanEffects isScanning={isScanning} />}
        </css.qrWrap>
    );
}

export default TicketQr;
